// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"40af36ad","817":"4da49c03"}[chunkId] + ".chunk.js";
};